exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".show-tools{margin-left:auto!important}.ck-editor__editable_inline{min-height:250px}.ck.ck-editor__editable>.ck-placeholder:before{color:#c0c4cc;font-size:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-65783e5e","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/CKEditor.vue
// module id = QMWo
// module chunks = 0